<template>
  <div class="dk-rich-editor">
    <div :id="editorId" class="editor" ref="editorHost"></div>
  </div>
</template>
<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import E from 'wangeditor'
import hljs from 'highlight.js'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'

let editorSeq = 0

export default {
  name: 'Editor',
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '在此编辑商品图文详情，可直接排版、插入图片…'
    },
    /* 高度 */
    height: {
      type: Number,
      default: 280
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024
    },
    imageSize: {
      type: Number,
      default: 5
    },
    videoSize: {
      type: Number,
      default: 1024
    },
    /* 弹层内使用时需高于 Modal/Drawer，避免工具栏下拉被遮挡 */
    zIndex: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*'
      },
      editor: null,
      currentValue: '',
      editorId: `dk-editor-${Date.now()}-${++editorSeq}`
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val !== this.currentValue) {
          this.currentValue = val === null ? '' : val
          if (this.editor) {
            this.editor.txt.html(this.currentValue)
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$nextTick(() => this.init())
  },
  beforeDestroy () {
    this.destroyEditor()
  },
  methods: {
    destroyEditor () {
      if (this.editor) {
        try {
          this.editor.destroy()
        } catch (e) { /* ignore */ }
        this.editor = null
      }
    },
    init () {
      var that = this
      this.destroyEditor()
      const host = this.$refs.editorHost
      if (!host) return
      this.editor = new E(host)
      // 代码高亮
      this.editor.highlight = hljs
      // 高度设置
      if (this.height) {
        this.editor.config.height = this.height
      }
      // z-index：弹窗内编辑器需高于 ant Modal
      this.editor.config.zIndex = this.zIndex
      // 占位提示
      this.editor.config.placeholder = this.placeholder
      // 自定义提示信息
      this.editor.config.customAlert = function (s, t) {
        switch (t) {
          case 'success':
            that.$message.success(s)
            break
          case 'info':
            that.$message.info(s)
            break
          case 'warning':
            that.$message.warning(s)
            break
          case 'error':
            that.$message.error(s)
            break
          default:
            that.$message.info(s)
            break
        }
      }
      // 图片
      this.editor.config.uploadImgMaxSize = 1024 * 1024 * this.imageSize
      this.editor.config.uploadFileName = 'file'

      this.editor.config.customUploadImg = (files, insert) => {
        new UploadFileToOSS(files, {
          finally: (results) => {
            const uploaded = (results || []).filter(item => item && item.url)
            uploaded.forEach(item => insert(item.url))
            if (uploaded.length === files.length) {
              this.$message.success('上传成功')
            } else {
              this.$message.error(uploaded.length ? '部分文件上传失败，请重试失败的文件' : '上传失败，请重试')
            }
          }
        })
      }

      // 视频
      this.editor.config.uploadVideoMaxSize = 1024 * 1024 * this.videoSize
      this.editor.config.uploadVideoName = 'file'
      this.editor.config.customUploadVideo = (files, insert) => {
        new UploadFileToOSS(files, {
          finally: (results) => {
            const uploaded = (results || []).filter(item => item && item.url)
            uploaded.forEach(item => insert(item.url))
            if (uploaded.length === files.length) {
              this.$message.success('上传成功')
            } else {
              this.$message.error(uploaded.length ? '部分文件上传失败，请重试失败的文件' : '上传失败，请重试')
            }
          }
        })
      }
      // 数据双向绑定
      this.editor.config.onchange = function (newHtml) {
        that.currentValue = newHtml
        that.$emit('input', newHtml)
      }
      this.editor.create()
      this.editor.txt.html(this.currentValue || '')
      if (this.readOnly) {
        this.editor.disable()
      }
    },
    handleUploadError () {
      this.$message.error('图片插入失败')
    }
  }
}
</script>

<style scoped>
.dk-rich-editor {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}
.dk-rich-editor >>> .w-e-toolbar {
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0 !important;
  flex-wrap: wrap;
}
.dk-rich-editor >>> .w-e-text-container {
  border: none !important;
}
.dk-rich-editor >>> .w-e-text {
  min-height: 180px;
  padding: 8px 12px;
}
.dk-rich-editor >>> .w-e-text img {
  max-width: 100%;
  height: auto;
}
</style>
